module.exports = __webpack_public_path__ + "img/mutai_content_tow.ab324769.png";